<template>
  <div class="tooltip" :style="{ left: left, top: top }">
    <div class="icon" :class="{'text-icon': iconText, 'small': iconText === 'i'}" @click="toggleInfo">
      <img v-if="image" :src="imgPath" alt="">
      <span v-if="iconText">{{iconText}}</span>
    </div>
    <div class="info" :class="{'small': copy && copy.length < 120 || headline && !copy && headline.length < 50 || small}">
      <h4 v-html="headline" v-if="headline" />
      <p v-html="copy" v-if="copy" />
    </div>
    <teleport to="body">Bin
      <transition name="fade">
        <div class="mobile-info" v-if="infoOpen">
          <span class="background"></span>
          <div class="window">
            <h4 v-html="headline" v-if="headline" />
            <p v-html="copy" v-if="copy" />
            <button class="closer" @click="toggleInfo" />
          </div>
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    left: String,
    top: String,
    image: String,
    small: {
      type: Boolean,
      default: false
    },
    iconText: {
      type: String,
      default: ''
    },
    headline: String,
    copy: String
  },
  data() {
    return {
      imgPath: this.image ? require('../assets/images/' + this.image) : '',
      infoOpen: false
    }
  },
  methods: {
    toggleInfo() {
      this.infoOpen = !this.infoOpen;
    }
  }
}
</script>

<style scoped>
  .tooltip {
    position: absolute;
    display: block;
    z-index: 0;
    transition: z-index 0s linear 0.3s;
  }
  .icon {
    position: absolute;
    width: 40px;
    height: 40px;
    background-color: #102D61;
    border-radius: 50%;
    margin: -20px;
    transition: 0.3s ease;
    box-shadow: 0 0 0 2px rgba(16, 45, 97, 0);
    cursor: pointer;
    padding: 6px;
  }
  .icon.text-icon {
    background-color: #009aa4;
    color: white;
    font-weight: 700;
    text-align: center;
    width: 34px;
    height: 34px;
    line-height: 34px;
    font-size: 26px;
    padding: 0;
    margin: -17px;
    box-shadow: 0 0 0 2px rgba(0, 154, 164, 0);
  }
  .icon.small {
    width: 20px;
    height: 20px;
    margin: -10px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 500;
  }
  .icon.small + .info {
    bottom: 28px;
  }
  .info {
    position: absolute;
    display: block;
    bottom: 34px;
    left: 50%;
    transform: translate3d(-50%, -15px, 0);
    background-color: #fff;
    box-shadow: 0 3px 20px -8px rgba(0, 0, 0, 0.4);
    opacity: 0;
    pointer-events: none;
    transition: 0.3s ease;
    font-size: 14px;
    width: 460px;
    padding: 24px 30px 20px;
  }
  .info.small {
    width: 320px;
  }
  .info:before {
    content: "";
    position: absolute;
    display: block;
    bottom: 0;
    left: 50%;
    width: 30px;
    height: 30px;
    margin: -15px;
    transform: rotate(45deg);
    background-color: #fff;
    box-shadow: 0 3px 20px -8px rgba(0, 0, 0, 0.4);
    z-index: -1;
  }
  .info:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    height: 40px;
    bottom: 0;
    background-color: #fff;
    z-index: -1;
  }
  .tooltip:hover {
    transition: z-index 0s linear 0s;
    z-index: 10;
  }
  .tooltip:hover .icon {
    box-shadow: 0 0 0 6px rgba(16, 45, 97, 0.6);
  }
  .tooltip:hover .icon.text-icon {
    box-shadow: 0 0 0 5px rgba(0, 154, 164, 0.6);
  }
  .tooltip:hover .icon.small {
    box-shadow: 0 0 0 4px rgba(0, 154, 164, 0.6);
  }
  .tooltip:hover .info {
    opacity: 1;
    pointer-events: all;
    transform: translate3d(-50%, 0, 0);
  }
  h4, h6 {
    font-size: 16px;
    color: #C7125C;
    margin: 0 0 0.4em;
  }
  .info p, .mobile-info p {
    margin-bottom: 5px;
  }
  .mobile-info {
    position: fixed;
    display: none;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 101;
    background-color: rgba(16, 45, 97, 0.8);
  }
  .window {
    position: relative;
    width: 92%;
    max-width: 480px;
    padding: 36px 40px 32px;
    background-color: #fff;
    box-shadow: 0 10px 50px -15px rgba(0, 0, 0, 0.5);
    font-weight: 400;
    font-size: 14px;
    transition: transform 0.4s ease;
    transform: translate3d(0, 0, 0) scale(1);
  }
  .closer {
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 50px;
    background-color: transparent;
    border: 0;
    cursor: pointer;
  }
  .closer:before, .closer:after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -1px -12px;
    width: 24px;
    height: 2px;
    background-color: #102D61;
    transform: rotate(45deg);
  }
  .closer:after {
    transform: rotate(-45deg);
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s ease;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-from .window,
  .fade-leave-to .window {
    transform: translate3d(0, 0, 0) scale(0.8);
  }
  @media(max-width: 1299px) {
    .info {
      width: 400px;
    }
  }
  @media(max-width: 1199px) {
    .info {
      position: fixed;
      left: 5vw;
      width: 90vw;
      transform: translate3d(0, 20px, 0);
      bottom: 0;
    }
    .tooltip:hover .info {
      opacity: 1;
      pointer-events: all;
      transform: translate3d(0, 0, 0);
    }
    .info:before {
      display: none;
    }
    .mobile-info {
      display: flex;
    }
  }
  @media(max-width: 767px) {
    .window {
      padding: 22px 26px 12px;
    }
    .window h4, .window h6 {
      padding-right: 30px;
    }
  }
</style>